import {
  CONSULTAMEDTURNOS_SUCCESS,
  CONSULTAMEDTURNOS_LOADING,
  CONSULTAMEDTURNOS_ERROR,
  CONSULTAMEDTURNOS_LOGOUT,
} from "../../ActionTypes";

import axiosLogin from "global/helpers/axiosLogin";

export const wsGetVerificaConsultaMedica =
  (especialidad, medico, idPacFamiliar, osAlternativa, nextStep) => (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/turnos/verificarOs/${especialidad}/${medico}/${
            idPacFamiliar ? idPacFamiliar : -1
          }/${osAlternativa ? osAlternativa : false}`
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const wsPostConsultaMedTurnos =
  (
    especialidad,
    agenda,
    fecha,
    particular,
    vc,
    idPacFamiliar,
    osAlternativa,
    nextStep
  ) =>
  (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/turnos/consulta_medica/turnosDisponibles/${especialidad}/${agenda}/${fecha}/${particular}/${vc}/${
            idPacFamiliar ? idPacFamiliar : -1
          }/${!osAlternativa ? "" : osAlternativa}`
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: err?.data });
          if (nextStep) nextStep(false, err?.response?.data);
        });
    });
  };

export const wsPostTomarTurnoConsultaMed =
  (requestBody, idPariente, nextStep) => (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .post(
          `his/turnos/consulta_medica/turno/${idPariente ? idPariente : -1}`,
          requestBody
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: err?.data });
          if (nextStep) nextStep(false, err?.response?.data);
        });
    });
  };

export const logoutConsultaMedTurnos = () => (dispatch) => {
  dispatch({ type: CONSULTAMEDTURNOS_LOGOUT });
};
